export default __webpack_public_path__ + "static/media/img-0453-luxembourg-premium-face.6f8851c2.png";